/**
 * Геттер для урл параметров
 * @returns {string} - сам параметр / {boolean} - false если параметра нет
 */
export default function $_GET(key:any): any
{
	let s: string = window.location.search;
	let match: any = s.match( new RegExp(key + '=([^&=]+)') );
	return match ? match[1] : false;
}
